import React, { Component } from 'react'

import './MobileRegister.css';

import PhoneNumber from './PhoneNumber/PhoneNumber.js';
import AuthCode from './AuthCode/AuthCode.js';
import AccountInfo from './AccountInfo/AccountInfo.js';

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = {
      level: 1,
      back: false,
      phoneNumber: '',
      auth_code1: '',
      auth_code2: '',
      auth_code3: '',
      auth_code4: '',
    }
  }

  setLevel = lvl => {
    this.setState({
      level: lvl,
    })
  }

  back = () => {
    if (this.state.level === 0) {
      window.history.back();
    } else {
      this.setState({
        level: this.state.level - 1,
        back: true,
      })
    }
  }

  changeValue = (name, value) => {
    this.setState({
      [name]: value,
    })
  }

  render() {
    const { level } = this.state;
    let section;
    if (level === 0) {
      section = <AccountInfo setLevel={this.setLevel} />;
    } else if (level === 1) {
      section = <PhoneNumber setLevel={this.setLevel} backAnimate={this.state.back} changeValue={this.changeValue} />;
    } else if (level === 2) {
      section = <AuthCode setLevel={this.setLevel} back={this.back} next={this.state.auth_code1 && this.state.auth_code2 && this.state.auth_code3 && this.state.auth_code4} />;
    }
    return (
      <div className="register d-flex">
        {section}
      </div>
    );
  }
}


export default Register;